export default class ErrorLayer {
    constructor(messages) {
        this.type = 'error';
        this.messages = messages;
    }
}
